import React, { useMemo } from 'react';
import Location from '@solvhealth/types/interfaces/Location';
import { useTranslation } from 'react-i18next';
import { CovidTestSlugs, getLocationPerformingCopy } from '../util';
import { isString } from '../../../../../core/util/string';
import { StyledBody } from '../CSSstyles';

type Props = {
  locationPerforming?: any[];
  testType: string;
  location: Location;
};

const LocationPerforming = ({ locationPerforming, testType, location }: Props) => {
  const { t } = useTranslation('pass');

  let locationPerformingCopy = useMemo(() => {
    return getLocationPerformingCopy(locationPerforming, location, t);
  }, [location, locationPerforming, t]);

  const genericSampleCollectionCopy =
    'Clinic staff will collect a sample by a nasal swab, mouth swab, or saliva test, depending on the type of testing available at the clinic.';

  if (testType === CovidTestSlugs.COVID_TEST && isString(locationPerformingCopy)) {
    locationPerformingCopy = (locationPerformingCopy as string)
      .split(' ')
      .map((w) => (w === 'test' ? `COVID ${w}` : w))
      .join(' ');
  }

  return (
    <>
      <li>
        <StyledBody>{locationPerformingCopy}</StyledBody>
      </li>
      <li>
        <StyledBody>{genericSampleCollectionCopy}</StyledBody>
      </li>
    </>
  );
};

export default LocationPerforming;
